import { usePrimeVue } from "primevue/config";

import { Language } from "@/data/model/Enums";

import primevueDe from "@/components/language/primevue/de";
import primevueEn from "@/components/language/primevue/en";
import primevueFr from "@/components/language/primevue/fr";
import primevueIt from "@/components/language/primevue/it";

export function setPrimevueLocale(language: Language) {
    const primevue = usePrimeVue();
    const currentLocale = getLocale(language);
    if (primevue?.config?.locale) {
        primevue.config.locale = currentLocale;
    }
}

function getLocale(language: Language) {
    switch (language) {
        case Language.German:
            return primevueDe.de;
        case Language.English:
            return primevueEn.en;
        case Language.French:
            return primevueFr.fr;
        case Language.Italian:
            return primevueIt.it;
        default:
            return primevueDe.de;
    }
}
